import React from 'react';

import { styled } from 'styled-components';

import { formatDate } from 'utils/formatting';

export const ArticleDateWrapper = styled.time`
  display: inline-block;
  border-bottom: 1px solid ${(props) => props.theme.colors.primaryRed};
  text-transform: uppercase;
  padding-bottom: 0.15rem;
  font-size: 0.8125rem;
  font-weight: 600;
  margin-bottom: 0.75rem;
`;

export const ArticleDate = ({ date }: { date: string }) => {
  const formattedDate = formatDate(date);

  if (!formattedDate || formattedDate.toLowerCase() === 'invalid date') {
    return <></>;
  }

  return <ArticleDateWrapper dateTime={date}>{formattedDate}</ArticleDateWrapper>;
};
